import { render, staticRenderFns } from "./PageTabsContent.vue?vue&type=template&id=4975d551"
import script from "./PageTabsContent.vue?vue&type=script&lang=ts"
export * from "./PageTabsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports